import { Icon } from "@zapier/zinnia-icons";
import { Colors, LegacyButton } from "@zapier/design-system";
import { styled } from "lib/theme";
import { fontSans } from "lib/fonts";
import { config } from "@/config";

/**
 * We have to use inline styles for some of the properties
 * because we can't import a CSS file with @tailwind directives into `layout.tsx` which in turns
 * is used by `global-error` and `not-found` components in the app directory.
 *
 * See https://zapier.slack.com/archives/C048W40M39S/p1747752392322689
 */
const Wrapper = styled.section`
  box-sizing: border-box;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${Colors.GrayWarm2};
  font-family: ${fontSans.style.fontFamily};
`;

const InnerWrapper = styled.div`
  background-color: ${Colors.PrimeWhite};
  box-sizing: border-box;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 700px;
  padding: 30px 0;
  border-radius: 12px;
  border: 1px solid ${Colors.GrayWarm4};
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const LogoText = styled.h1`
  font-size: 24px;
  font-weight: 600;
  font-family: ${fontSans.style.fontFamily};
  margin: 0;
  font-size: 24px;
  font-weight: 600;
`;

const ExplainText = styled.h2`
  font-size: 18px;
  color: ${Colors.GrayWarm10};
  text-align: center;
  font-family: ${fontSans.style.fontFamily};
  box-sizing: border-box;
  font-weight: inherit;
  margin: 0;
  font-size: 18px;
  color: #201515;
  text-align: center;
`;

const GoHomeLink = styled.a`
  font-family: ${fontSans.style.fontFamily};
  box-sizing: border-box;
  color: inherit;
  text-decoration: none;
`;

export function GenericError() {
  return (
    <Wrapper>
      <InnerWrapper>
        <LogoWrapper>
          <Icon isBlock color="BrandOrange" name="navInterfaces" size={30} />
          <LogoText>Interfaces</LogoText>
        </LogoWrapper>
        <ExplainText>An unexpected error occurred</ExplainText>
        <LegacyButton
          href={`${config().NEXT_PUBLIC_INTERFACES_BASE_URL}/interfaces`}
        >
          Back to home
        </LegacyButton>
      </InnerWrapper>
    </Wrapper>
  );
}

export function Error404() {
  return (
    <Wrapper>
      <InnerWrapper>
        <LogoWrapper>
          <Icon isBlock color="BrandOrange" name="navInterfaces" size={30} />
          <LogoText>Interfaces</LogoText>
        </LogoWrapper>
        <ExplainText>Your page could not be found (error 404).</ExplainText>
        <GoHomeLink
          href={`${config().NEXT_PUBLIC_INTERFACES_BASE_URL}/interfaces`}
        >
          Back to home
        </GoHomeLink>
      </InnerWrapper>
    </Wrapper>
  );
}

export function Error500() {
  return (
    <Wrapper>
      <InnerWrapper>
        <LogoWrapper>
          <Icon isBlock color="BrandOrange" name="navInterfaces" size={30} />
          <LogoText>Interfaces</LogoText>
        </LogoWrapper>
        <ExplainText>An unexpected error has occurred.</ExplainText>
        <LegacyButton
          href={`${config().NEXT_PUBLIC_INTERFACES_BASE_URL}/interfaces`}
        >
          Back to home
        </LegacyButton>
      </InnerWrapper>
    </Wrapper>
  );
}
